<template>
  <div  class="s-receive" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <!--领取类进度-->
    <div v-if="isProgress">
      <div v-for="(item,index) in totalAward" :key="'progress-'+index" :style="{...progressPositionList[index]}">
        <div :desc="item.name" v-if="progressPositionList[index] &&  progressPositionList[index].flag && progressPositionList[index].flag == 1">({{item.condition_ret.actual_val}}/{{item.condition_ret.expect_val}})</div>
      </div>
    </div>
    <!--领取类按钮-->
    <div v-for="(item,index) in totalAward" :key="index" style="font-size: 0" :style="{...btnPositionList[index]}" :desc="item.name">
      <img v-if="item.status === 0 && $MainWrap.btnNoBegin.src" :src="$MainWrap.btnNoBegin.src" style="width: 100%; height: 100%;" alt="">
      <img v-if="item.status === 1 && $MainWrap.btnNoFix.src" :src="$MainWrap.btnNoFix.src" style="width: 100%; height: 100%;" alt="">
      <img v-if="item.status === 2 && $MainWrap.btnReceive.src" :src="$MainWrap.btnReceive.src" style="width: 100%; height: 100%;" alt="" @click="receiveFun(item)">
      <img v-if="item.status === 3 && $MainWrap.btnAlreadyReceive.src" :src="$MainWrap.btnAlreadyReceive.src" style="width: 100%; height: 100%;" alt="">
      <img v-if="item.status === 4 && $MainWrap.btnExpire.src" :src="$MainWrap.btnExpire.src" style="width: 100%; height: 100%;" alt="">
    </div>
    <div v-if="isCumulativeLogin" style="position: absolute;" :style="{...cumulativeLoginPositionList[0]}">{{ loginCount || 0 }}</div>
  </div>
</template>

<script>
import SAnimateImage from "@/components/BuilderComponents/AnimateImage/index.vue";

export default {
  name: 'SVersionReceive',
  components: { SAnimateImage },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnPositionList: {
      type: Array,
      required: true
    },
    isSignIn: {
      type: Boolean,
      default: false
    },
    signInId: {
      type: String,
      default: ''
    },
    isProgress: {
      type: Boolean,
      default: false
    },
    progressPositionList: {
      type: Array,
      required: true
    },
    isInviteAward: {
      type: Boolean,
      default: false
    },
    isCumulativeLogin: {
      type: Boolean,
      default: false
    },
    cumulativeLoginPositionList: {
      type: Array,
      required: true
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  data () {
    return {
      loginCount: 0,
      totalAward: []
    }
  },
  mounted () {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getCheckStatus)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
    this.getCheckStatus()
  },
  methods: {
    // 获取首页信息
    async getCheckStatus () {
      // 签到初始化
      if (this.isSignIn && window.$checkLogin()) {
        await this.signInFun();
      }
      // 获取累登活动
      this.getCumulativeAct()
    },
    // 重置
    reset () {
      this.getCumulativeAct()
    },
    // 签到
    async signInFun () {
      await this.requestAPI({
        url: '/v1/uni/official/sign',
        method: 'get',
        params: { a_id: this.signInId }
      }).catch((err) => {
        console.error(err)
      })
    },
    // 获取活动信息
    getCumulativeAct () {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId }
      }).then((res) => {
        if (res.groups.length <= 0) {
          return
        }
        this.totalAward = [...res.groups]
        if (this.isCumulativeLogin) {
          this.loginCount = (res.groups && res.groups.length > 0) ? res.groups[res.groups.length - 1].condition_ret.actual_val : 0
        }
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 点击累计立即领取
    receiveFun (item) {
      if (!window.$checkLogin()) return
      let url = "/v1/uni/receive"
      if (this.isInviteAward) {
        url = "/v1/uni/official/team-award"
      } else {
        url = '/v1/uni/receive'
      }
      this.requestAPI({
        url,
        method: 'get',
        params: { a_id: this.activityId, g_id: item.id }
      }).then((res) => {
        if (!this.isInviteAward) {
          this.$MainWrap.openVersionDialogTipSuccess(res.gift.materials)
        } else {
          this.$MainWrap.openVersionDialogTip({
            content: '领取成功',
            btnCancelText: ''
          })
          this.$MainWrap.init()
        }
        this.getCumulativeAct()
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.s-receive{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
